import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CsIconModule, TooltipModule } from '@cbuild/controls';
import { ContentDirective } from './content.directive';
import { LayoutComponent } from './layout.component';
import { LeftPanelDirective } from './left-panel.directive';
import { LeftPanelComponent } from './left-panel/left-panel.component';

@NgModule({
  declarations: [
    LayoutComponent,
    LeftPanelComponent,
    LeftPanelDirective,
    ContentDirective
  ],
  imports: [CommonModule, CsIconModule, TooltipModule, RouterModule],
  exports: [
    LayoutComponent,
    LeftPanelDirective,
    ContentDirective,
    LeftPanelComponent
  ]
})
export class LayoutModule {}
